import { render, staticRenderFns } from "./ModalNotePreview.vue?vue&type=template&id=55f06d88&"
import script from "./ModalNotePreview.vue?vue&type=script&lang=js&"
export * from "./ModalNotePreview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports